import React, { Suspense, Fragment, useEffect } from 'react'
import { Route, withRouter } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { connect } from 'react-redux'
import Cookies from 'js-cookie'
import Header from '../header'
import AppRouter from '../../routes'
import Login from '@/pages/login'
import Register from '@/pages/register'
import ForgetPassword from '@/pages/forget-password'
import AppMenu from 'components/menu'
import Breadcrumb from '../breadcrumb'
import Sidebar from '../sidebar'
import { TOKEN_KEY } from '../../constants'
import * as actionCreators from '@/store/actionCreators'
import './style.scss'

function Container(props) {
  const { isLogin, getAllEnum, getLoginUser, getPersonalize, loginUser } = props
  useEffect(() => {
    if (isLogin && Cookies.get(TOKEN_KEY)) {
      getAllEnum()
      getLoginUser()
      getPersonalize()
    } else {
      if (['/register', '/forgetPassword'].includes(props.location.pathname)) {
        props.history.replace(props.location.pathname + props.location.search)
      } else {
        props.history.replace('/login')
      }
    }
  }, [isLogin])

  useEffect(() => {
    if (!isLogin || !loginUser || !Object.keys(loginUser).length) {
      return
    }
    // 👇 检查关键字段是否存在，如果不存在说明还没加载完整或字段缺失
    if (!('isLevel1Customer' in loginUser)) {
      return // 等待完整数据加载
    }
    const notAllowMenu = ['/customer', '/shop', '/finance']
    const isForbidden = notAllowMenu.some((path) => props.location.pathname.startsWith(path))
    if (!loginUser.isLevel1Customer && isForbidden) {
      console.log('loginUser.isLevel1Customer', loginUser.isLevel1Customer)
      props.history.replace('/')
    }
  }, [loginUser, props.location.pathname])

  return (
    <div className="container">
      <>
        <Route path="/login" component={Login}/>
        <Route path="/register" component={Register}/>
        <Route path="/forgetPassword" component={ForgetPassword}/>
      </>
      {isLogin && (
        <Fragment>
          <AppMenu/>
          <Sidebar/>
          <div className="content">
            <Header/>
            <div className="page">
              {props.location.pathname !== '/' && <Breadcrumb/>}
              <div className={props.location.pathname === '/' ? 'page--content page--content-home' : 'page--content'}>
                <Suspense fallback={<Spin indicator={<LoadingOutlined/>}/>}>
                  <AppRouter/>
                </Suspense>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default connect(state => ({
  isLogin: state.getIn(['common', 'isLogin']),
  loginUser: state.getIn(['common', 'loginUser'])
}), dispatch => ({
  getAllEnum() {
    dispatch(actionCreators.getAllEnum())
  },
  getLoginUser() {
    dispatch(actionCreators.getLoginUser())
  },
  getPersonalize() {
    dispatch(actionCreators.getPersonalize())
  }
}))(withRouter(Container))
